// BARCINO — Fiche coffret (hors Barba)
import Swiper from 'swiper/bundle';

// Le swiper composition s'active dès plus de 3 cartes (tous écrans) OU en
// dessous du desktop (≤992px) quel que soit le nombre — plus élégant qu'une
// grille sur mobile/tablette. Au-dessus, grille classique.
const COMPOSITION_SWIPER_MAX = 992;

const barcinoCoffret = {
    _el: null,
    _quantity: 1,
    _imageIndex: 0,
    _compositionSwiper: null,
    _onResize: null,

    init() {
        this._el = document.querySelector('[data-coffret-detail]');
        if (!this._el) return;

        this._bindGallery();
        this._bindQuantity();
        this._bindLearnMore();
        this._syncCompositionSwiper();

        this._onResize = () => this._syncCompositionSwiper();
        window.addEventListener('resize', this._onResize, { passive: true });
    },

    destroy() {
        if (this._onResize) {
            window.removeEventListener('resize', this._onResize);
            this._onResize = null;
        }
        this._el = null;
        this._quantity = 1;
        this._imageIndex = 0;
        this._destroyCompositionSwiper();
    },

    _syncCompositionSwiper() {
        const el = this._el.querySelector('[data-coffret-composition-swiper]');
        if (!el) return;

        const cards = Array.from(el.querySelectorAll('.bc-coffret-composition__item'));
        if (!cards.length) return;

        const shouldSwipe = cards.length > 3 || window.innerWidth <= COMPOSITION_SWIPER_MAX;

        if (shouldSwipe && !this._compositionSwiper) {
            const wrapper = document.createElement('div');
            wrapper.className = 'swiper-wrapper';
            cards.forEach((card) => {
                card.classList.add('swiper-slide');
                wrapper.appendChild(card);
            });
            el.appendChild(wrapper);
            el.classList.add('swiper');

            this._compositionSwiper = new Swiper(el, {
                slidesPerView: 1.12,
                spaceBetween: 16,
                grabCursor: true,
                a11y: { slideRole: '' },
                breakpoints: {
                    601: {
                        slidesPerView: 2.15,
                        spaceBetween: 24,
                    },
                    993: {
                        slidesPerView: 3.15,
                        spaceBetween: 24,
                    },
                },
            });
        } else if (!shouldSwipe && this._compositionSwiper) {
            this._destroyCompositionSwiper();
        }
    },

    _destroyCompositionSwiper() {
        if (this._compositionSwiper) {
            this._compositionSwiper.destroy(true, true);
            this._compositionSwiper = null;
        }

        const el = document.querySelector('[data-coffret-composition-swiper]');
        if (!el) return;

        const wrapper = el.querySelector('.swiper-wrapper');
        if (wrapper) {
            Array.from(wrapper.children).forEach((card) => {
                card.classList.remove('swiper-slide');
                el.appendChild(card);
            });
            wrapper.remove();
        }
        el.classList.remove('swiper', 'swiper-initialized');
    },

    _bindLearnMore() {
        this._el.querySelector('[data-open-description]')?.addEventListener('click', (event) => {
            const details = this._el.querySelector('#coffret-description');
            if (!details) return;

            event.preventDefault();
            details.open = true;
            details.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    },

    _bindGallery() {
        const images = this._el.querySelectorAll('[data-coffret-image]');
        if (images.length < 2) return;

        const show = (index) => {
            this._imageIndex = (index + images.length) % images.length;
            images.forEach((image, imageIndex) => {
                image.classList.toggle('is-active', imageIndex === this._imageIndex);
            });
        };

        this._el.querySelector('[data-coffret-gallery-previous]')?.addEventListener('click', () => show(this._imageIndex - 1));
        this._el.querySelector('[data-coffret-gallery-next]')?.addEventListener('click', () => show(this._imageIndex + 1));
    },

    _stock() {
        const stockEl = this._el.querySelector('[data-coffret-stock]');
        return Number.parseInt(stockEl?.dataset.coffretStock || '0', 10);
    },

    _bindQuantity() {
        this._el.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
            this._quantity = Math.max(1, this._quantity - 1);
            this._refreshQuantity();
        });
        this._el.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
            this._quantity = Math.min(Math.max(1, this._stock()), this._quantity + 1);
            this._refreshQuantity();
        });
    },

    _refreshQuantity() {
        this._el.querySelector('[data-product-quantity]').textContent = this._quantity;
        const addButton = this._el.querySelector('[data-cart-add]');
        addButton.dataset.cartQty = String(this._quantity);
        const unitPrice = Number.parseFloat(addButton.dataset.unitPrice || '0');
        addButton.textContent = addButton.dataset.labelAdd.replace('%s', this._formatPrice(unitPrice * this._quantity));
    },

    _formatPrice(price) {
        const locale = document.documentElement.lang === 'en' ? 'en-GB' : 'fr-FR';
        return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(price);
    },
};

export default barcinoCoffret;
